<template>
    <div class="public-offer-upcell">
        <default-title :size="16" :line-height="21">
            {{ t("payments.public-offer.options") }}
        </default-title>
        <public-offer-item
            @select="selectOffer(offer)"
            @check="checkOffer(offer)"
            @update="$emit('update')"
            :key="index"
            :offer="offer"
            :order="order"
            :show-partial-price="showPartialPrice"
            :payment="payment"
            :payment-parts="paymentParts"
            :showFreeTitle="showFreeTitle"
            type="upsell"
            v-for="(offer, index) in upsell"
        />
    </div>
</template>

<script>
import DefaultTitle from "@components/Typography/DefaultTitle"
import PublicOfferItem from "./PublicOfferItem"
import PublicOfferOrderItem from "./PublicOfferOrderItem.vue"

export default {
    components: { PublicOfferOrderItem, PublicOfferItem, DefaultTitle },
    props: {
        paymentParts: {
            type: Array,
            default: () => []
        },
        payment: {
            type: Object,
            default: null
        },
        showPartialPrice: {
            type: Boolean,
            default: false
        },
        offer: {
            type: Object,
            required: true,
            default: () => {}
        },
        order: {
            type: Object,
            required: true,
            default: () => {}
        },
        upsell: {
            type: Array,
            required: true
        },
        showFreeTitle: {
            type: Boolean,
            default: false
        }
    },
    name: "PublicOfferUpsell",
    methods: {
        checkOffer(offer) {
            // offer.is_checked = !offer.is_checked
            this.upsell.forEach(el => {
                if (el.id === offer.id) el.is_checked = !offer.is_checked
            })
        },
        selectOffer(offer) {
            this.upsell.forEach(offer => {
                offer.is_selected = false
            })
            offer.is_selected = true

            // Update cross-sells after changing upsell
            this.$emit("updateCrossSells")
        }
    }
}
</script>

<style scoped lang="sass">
.public-offer-upcell
    padding: 20px
    background: #fff
    border-radius: 10px
    box-shadow: 0 4px 10px rgba(128, 158, 191, 0.15)
    @media (max-width: 640px)
        padding: 10px
    .default-title
        margin-bottom: 20px
</style>
